import React from 'react'

//STYLES___________________________
import '../teacherdashboards.css'

//UI_________________________
import { Avatar } from 'antd'

export default function Student({ student, withPercentage, size = 'medium', onClick,  }) {
    return (
        <div style={styles.container} onClick={() => onClick ? onClick(student) : console.log('click')}>
            <Avatar src={student.avatar ? `${global.URI_FRONTEND}/images/avatar/${student.id}.jpg` : `${global.URI_FRONTEND}/images/avatar/_male-default.jpg`} size={size === 'small' ? 40 : 56} shape="square" style={size === 'small' ? styles.avatar_small : styles.avatar_medium} />
            <div style={styles.text_container}>
                <h3 style={styles.tableStudentName} className="student-name">{student.name}</h3>
                {
                    withPercentage &&
                    <h4 style={styles.subtitle}>Moyenne: {student.percentage}%</h4>
                }
            </div>
        </div>
    )
}

const styles = {
    tableStudentName: {
        color: '#010031',
        fontWeight: 600,
        fontSize: '14px',
        margin: 0,
        textAlign: 'left',
        fontFamily: '"Poppins", sans-serif'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        padding: 10,
        cursor: 'pointer'
    },
    subtitle: {
        fontWeight: 300,
        fontSize: '14px',
        color: '#010031',
        margin: 0,
        fontFamily: '"Poppins", sans-serif'
    },
    text_container: {
        marginLeft: 10
    },
    avatar_medium: {
        width: '56px',
        height: '56px'
    },
    avatar_small: {
        width: '40px',
        height: '40px'
    }
}
